import React from 'react';
import { useTranslation } from 'react-i18next';
import { Text } from '@eds-web/react';
import { StyledErrorContent } from '../access/AgeGated.style';

export const PayoutMaintenance: React.FC = () => {
    const { t } = useTranslation();
    return (
        <StyledErrorContent>
            <Text variant={'paragraphSM'} style={{ textAlign: 'center' }}>
                {t('epic.esport.hyperwallet.maintenance.message1')}
            </Text>
            <Text variant={'paragraphSM'} style={{ textAlign: 'center' }}>
                {t('epic.esport.hyperwallet.maintenance.message2')}
            </Text>
        </StyledErrorContent>
    );
};
